/**
 * RIFT — operator roster.
 *
 * One source of truth for both the home screen's inline OPERATOR FILE panel
 * (mainmenu.js) and the full PERSONNEL screen (personnel.js) — a player who
 * flips an operator on one always sees the same operator on the other.
 *
 * `unlockLevel` is compared against the player's level (mainmenu.js's
 * `_identity().level`) purely for front-end presentation — a "LOCKED" badge
 * and a disabled equip control. It is not an entitlement check: like the
 * loadout in armory.js, ownership that actually gated anything would have to
 * be asked of the server, not read off this array.
 */

export const OPERATORS = [
  {
    id: 'vanguard',
    name: 'VANGUARD',
    kit: 'ARID / COYOTE',
    weapon: 'MK18 CARBINE',
    sidearm: 'M1911 · SUPPRESSED',
    utility: 'FRAG · SMOKE',
    tagline: 'Point of the spear. First through the door, first on the objective.',
    unlockLevel: 1,
    missions: 312,
    kd: 2.41,
    winRate: 58,
    streak: 11,
  },
  {
    id: 'breacher',
    name: 'BREACHER',
    kit: 'URBAN / WOLF-GREY',
    weapon: 'MK18 CARBINE',
    sidearm: 'P-19 · SUPPRESSED',
    utility: 'FLASHBANG · C4',
    tagline: 'Close-quarters specialist. Runs the shotgun and the ram.',
    unlockLevel: 1,
    missions: 204,
    kd: 1.87,
    winRate: 52,
    streak: 6,
  },
  {
    id: 'irregular',
    name: 'IRREGULAR',
    kit: 'WOODLAND / OLIVE',
    weapon: 'AKS-74U',
    sidearm: 'REVOLVER',
    utility: 'SMOKE · CLAYMORE',
    tagline: 'Deniable asset. No insignia, no radio chatter, no mercy.',
    unlockLevel: 8,
    missions: 96,
    kd: 3.02,
    winRate: 61,
    streak: 14,
  },
  {
    id: 'warden',
    name: 'WARDEN',
    kit: 'ARCTIC / SNOW',
    weapon: 'M700-LR',
    sidearm: 'P-19',
    utility: 'SMOKE · SENSOR',
    tagline: 'Overwatch. Holds the long line so the squad does not have to.',
    unlockLevel: 20,
    missions: 0,
    kd: 0,
    winRate: 0,
    streak: 0,
  },
];
